//Bundle for the whole site

import 'bootstrap/dist/css/bootstrap.css';

// Custom CSS imports
import '../css/site.css';
